import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  Signin,
  LogoutCallback,
  RedirectCallback,
} from "../Authentication/Callbacks";
import PrivateRoute from "../Shared/PrivateRoute";
import PageLoader from "../Shared/PageLoader";
import SideBar from '../components/custom/sidebar';
import SidebarAddShip from '../components/custom/SidebarAddShip';
import SidebarEditShip from '../components/custom/SidebarEditShip';
import SidebarReport from '../components/custom/SidebarReport';
import SidebarShipDocument from '../components/custom/SidebarShipDocument';
import SidebarMasterData from "../components/custom/SidebarMasterData";
import SidebarUser from "../components/custom/SidebarUser";
import SidebarProjectMasterData from "../components/custom/SidebarProjectMasterData";
import Settings from "../components/Pages/Ships/Settings";
import ShipListview from '../components/Pages/Ships/ShipListview';
import DeleteShip from "../components/Pages/Ships/DeleteShip/DeleteShip";
import AddIC from "../components/Pages/Ships/InCharge/AddIC";
import AddSP from "../components/Pages/Ships/BasicInformation/AddBI";
import AddHL from "../components/Pages/Ships/HistoryLog/AddHL";
import Menu from "../components/Pages/TopMenu";
import PageNotFound from "../components/PageNotFound";
import UnautherizeContent from "../components/UnautherizeContent";
import UserExist from "../components/UserExist";
import FinalReport from '../components/Pages/ReportManagement/FinalReport';
import ChangePassword from "../components/Pages/Settings/ChangePassword";
import LViewOPA from "../components/Pages/MasterData/OPA/LViewOPA";
import AddEditOPA from "../components/Pages/MasterData/OPA/AddEditOPA";
import LViewAdmin from "../components/Pages/UserManagement/Admin/LViewAdmin";
import AddEditAdmin from "../components/Pages/UserManagement/Admin/AddEditAdmin";
import LViewInspector from "../components/Pages/UserManagement/FieldInspector/LViewInspector";
import AddEditInspector from "../components/Pages/UserManagement/FieldInspector/AddEditInspector";
import LViewClient from "../components/Pages/UserManagement/Client/LViewClient";
import AddEditClient from "../components/Pages/UserManagement/Client/AddEditClient";
import LViewExternalClient from "../components/Pages/UserManagement/ExternalClient/LViewExternalClient";
import AddEditExternalClient from "../components/Pages/UserManagement/ExternalClient/AddEditExternalClient";
import LViewExternalClientShips from "../components/Pages/ExternalClientShips/LViewExternalClientShips";
import AddEditExternalClientShips from "../components/Pages/ExternalClientShips/AddEditExternalClientShips";
import AddEditDC from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddDC";
import AddEditBTV from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditBTV";
import AddEditCS from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditCS";
import AddEditMMS from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditEMMS";
import AddEditFPD from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditFPD";
import AddEditFSA from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditFSA";
import AddEditGA from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditGA";
import AddEditHULL from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditHULL";
import AddEditLSE from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditLSE";
import AddEditMDF from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditMDF";
import AddEditNBC from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditNBC";
import AddEditPC from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditPC";
import AddEditEMMS from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditEMMS";
import AddEditSW from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditSW";
import AddEditDS from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditDS";
import AddEditOM from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditOM"
import AddEditCSN from "../components/Pages/Inspection Tasks/Text and Pictures&Notableitems/AddEditCSN";
import AddEditOPD from '../components/Pages/Inspection Tasks/OperationalData/ListViewOPD';
import ListViewVP from "../components/Pages/Inspection Tasks/VesselParticular/ViewVP";
import AddEditKNI from "../components/Pages/Inspection Tasks/KeyNotableItems/AddKNI";
import AddEditVP from "../components/Pages/Inspection Tasks/VesselParticular/AddEditVP";
import AddEditVDESC from "../components/Pages/Inspection Tasks/InspectionSummary/AddEditDESC";
import CompareAheadGrade from "../components/Pages/Inspection Tasks/CompareAheadGrade/CompareAheadGrade";
import AddEditGD from "../components/Pages/Inspection Tasks/GradingData/AddEditGD";
import AddEditBUCLS from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Bulker/AddEditDoc";
import AddEditBUCON from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Bulker/AddEditCargoBulker";
import AddEditBULIFT from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Bulker/AddEditHatchCoam";
import AddEditBUSEC from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Bulker/AddEditLift";
import AddEditBUSYS from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Bulker/AddEditHatchCover";
import AddEditCCLS from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Container/AddEditClosing";
import AddEditCCON from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Container/AddEditCondition";
import AddEditCLIFT from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Container/AddEditLifting";
import AddEditCSEC from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Container/AddEditSecuring";
import AddEditCSYS from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Container/AddEditSystems";
import AddEditTCAR from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Tanker/AddEditCargo";
import AddEditTMON from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Tanker/AddEditMonitor";
import AddEditTPUMP from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Tanker/AddEditPumping";
import AddEditCARGO from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LNG/AddEditCargoTankLNG";
import AddEditEQUIP from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LNG/AddEditEquipmentLNG";
import AddEditMONI from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LNG/AddEditMonitorLNG";
import AddEditPUM from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LNG/AddEditPumpingLNG";
import AddEditCARGOLPG from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LPG/AddEditCargoTankLPG";
import AddEditEQUIPLPG from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LPG/AddEditEquipmentLPG";
import AddEditMONILPG from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LPG/AddEditMonitorLPG";
import AddEditPUMLPG from "../components/Pages/Inspection Tasks/ShipSpecificCondition/Gas-LPG/AddEditPumpingLPG";
import axios from "axios";
import FinalSubmit from "../components/Pages/Inspection Tasks/FinalSubmit/FinalSubmit";
import Overview from "../components/Pages/Inspection Tasks/Overview/Overview";
import Documents from "../components/Pages/Documents/documents";
import ShipImages from "../components/Pages/ShipImages/shipImage";
import NewEnquiry from "../components/Pages/NewEnquiry/NewEnquiry";
import SampleListView from "../components/Pages/SampleShips/SampleShipListView"

class routes extends Component {
  componentWillMount() {
    axios.interceptors.request.use(
      (config) => {
        const userDetails = localStorage.getItem("currentUser");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.accessToken;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }
  render() {
    return (
      <>

        <Routes>
          <Route exact path="/" element={<Navigate to={"/login"} />} />
          <Route exact path="/login" element={<Signin />} />
          <Route exact path="/signin" element={<RedirectCallback />} />
          <Route exact path="/logout" element={<LogoutCallback />} />
          <Route path="/unautherized" element={<UnautherizeContent />} />
          <Route path="/usernotfound" element={<UserExist />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="" element={<PrivateRoute><Menu /><PageLoader /></PrivateRoute>}>
            {/*  <Route exact path="/" element={<Navigate to={"/shiplist"} />} /> */}
            <Route path="shiplist" element={<ShipListview />} />
            <Route path="shipparticulars/add" element={<AddSP />} />
            <Route path="shipparticulars/edit" element={<AddSP />} />
            <Route path="incharge/add" element={<AddIC />} />
            <Route path="incharge/edit" element={<AddIC />} />
            <Route path="settings/add" element={<Settings />} />
            <Route path="settings/edit" element={<Settings />} />
            <Route path="historylog" element={<AddHL />} />
            <Route path="deleteship/deleteship" element={<DeleteShip />} />
            <Route path="changepassword" element={<ChangePassword />} />
            <Route path="finalreport" element={<FinalReport />} />
            <Route path="lookupdata/opa" element={<LViewOPA />} />
            <Route path="lookupdata/opa/add" element={<AddEditOPA />} />
            <Route path="lookupdata/opa/edit" element={<AddEditOPA />} />
            <Route path="usermanagement/admin" element={<LViewAdmin />} />
            <Route path="usermanagement/admin/add" element={<AddEditAdmin />} />
            <Route path="usermanagement/admin/edit" element={<AddEditAdmin />} />
            <Route path="usermanagement/fieldinspector" element={<LViewInspector />} />
            <Route path="usermanagement/fieldinspector/add" element={<AddEditInspector />} />
            <Route path="usermanagement/fieldinspector/edit" element={<AddEditInspector />} />
            <Route path="usermanagement/client" element={<LViewClient />} />
            <Route path="usermanagement/client/add" element={<AddEditClient />} />
            <Route path="usermanagement/client/edit" element={<AddEditClient />} />
            <Route path="usermanagement/externalclient" element={<LViewExternalClient />} />
            <Route path="usermanagement/externalclient/add" element={<AddEditExternalClient />} />
            <Route path="usermanagement/externalclient/edit" element={<AddEditExternalClient/>} />
            <Route path="activesampleships" element={<LViewExternalClientShips />} />
            <Route path="activesampleships/add" element={<AddEditExternalClientShips />} />
            <Route path="activesampleships/edit" element={<AddEditExternalClientShips />} />
            <Route path="sampleships" element={<SampleListView />} />
            <Route path="newenquiry" element={<NewEnquiry />} />
            <Route path="inspection/vesselparticular" element={<AddEditVP />} />
            <Route path="inspection/vesselparticular/listview" element={<ListViewVP />} />
            <Route path="inspection/summary" element={<AddEditVDESC />} />
            <Route path="inspection/comparegrade" element={<CompareAheadGrade />} />
            <Route path="inspection/operationaldata" element={<AddEditOPD />} />
            <Route path="inspection/keynotableitems" element={<AddEditKNI />} />
            <Route path="inspection/gradingdata" element={<AddEditGD />} />
            <Route path="inspection/designconstruction" element={<AddEditDC />} />
            <Route path="inspection/hull" element={<AddEditHULL />} />
            <Route path="inspection/poopdeck" element={<AddEditFPD />} />
            <Route path="inspection/maindeck" element={<AddEditMDF />} />
            <Route path="inspection/ballasttanks" element={<AddEditBTV />} />
            <Route path="inspection/galleyaccomodation" element={<AddEditGA />} />
            <Route path="inspection/navigationbridge" element={<AddEditNBC />} />
            <Route path="inspection/engineroom" element={<AddEditEMMS />} />
            <Route path="inspection/safetyappliances" element={<AddEditFSA />} />
            <Route path="inspection/lifesavingequipment" element={<AddEditLSE />} />
            <Route path="inspection/safeworking" element={<AddEditSW />} />
            <Route path="inspection/decarbanizationsummary" element={<AddEditDS />} />
            <Route path="inspection/pollutioncontrol" element={<AddEditPC />} />
            <Route path="inspection/onboardmanagment" element={<AddEditOM />} />
            <Route path="inspection/cargosystem" element={<AddEditCS />} />
            <Route path="inspection/concludingstatement" element={<AddEditCSN />} />
            <Route path="inspection/container/cargocondition" element={<AddEditCCON />} />
            <Route path="inspection/container/cargosystems" element={<AddEditCSYS />} />
            <Route path="inspection/container/lifting" element={<AddEditCLIFT />} />
            <Route path="inspection/container/closing" element={<AddEditCCLS />} />
            <Route path="inspection/container/securing" element={<AddEditCSEC />} />
            <Route path="inspection/bulker/cargocondition" element={<AddEditBUCON />} />
            <Route path="inspection/bulker/cargosystems" element={<AddEditBUSYS />} />
            <Route path="inspection/bulker/lifting" element={<AddEditBULIFT />} />
            <Route path="inspection/bulker/closing" element={<AddEditBUCLS />} />
            <Route path="inspection/bulker/securing" element={<AddEditBUSEC />} />
            <Route path="inspection/tanker/cargotanks" element={<AddEditTCAR />} />
            <Route path="inspection/tanker/pipingsystem" element={<AddEditTPUMP />} />
            <Route path="inspection/tanker/monitoring" element={<AddEditTMON />} />
            <Route path="inspection/gascarrier/lng/equipment" element={<AddEditEQUIP />} />
            <Route path="inspection/gascarrier/lng/cargotanks" element={<AddEditCARGO />} />
            <Route path="inspection/gascarrier/lng/pipingsystem" element={<AddEditPUM />} />
            <Route path="inspection/gascarrier/lng/monitoring" element={<AddEditMONI />} />
            <Route path="inspection/gascarrier/lpg/equipment" element={<AddEditEQUIPLPG />} />
            <Route path="inspection/gascarrier/lpg/cargotanks" element={<AddEditCARGOLPG />} />
            <Route path="inspection/gascarrier/lpg/pipingsystem" element={<AddEditPUMLPG />} />
            <Route path="inspection/gascarrier/lpg/monitoring" element={<AddEditMONILPG />} />
            <Route path="inspection/finalsubmit" element={<FinalSubmit />} />
            <Route path="ship/finalsubmit" element={<FinalSubmit />} />
            <Route path="ship/overview" element={<Overview />} />
            <Route path="ship/documents" element={<Documents />} />
            <Route path="ship/photographs" element={<ShipImages />} />
            <Route path="sidebarprojectmasterdata" element={<SidebarProjectMasterData />} />
            <Route path="sidebarmasterdata" element={<SidebarMasterData />} />
            <Route path="sidebar" element={<SideBar />} />
            <Route path="SidebarUser" element={<SidebarUser />} />
            <Route path="sidebarshipdocument" element={<SidebarShipDocument />} />
            <Route path="sidebaraddship" element={<SidebarAddShip />} />
            <Route path="sidebareditship" element={<SidebarEditShip />} />
            <Route path="sidebarreport" element={<SidebarReport />} />
          </Route>
        </Routes>
      </>
    );
  }
}

export default routes;
